import { DataLayerVariable } from './dataLayerVariables';

export enum DataLayerEventList {
	NotVerifiedPlayerSurvey = 'not-verified-player-survey',
	PromotionChosenWhileRegistering = 'promotion-chosen-while-registering',
	BetError = 'bet_error',
	DepositFalse = 'deposit-false',
	RegStart2 = 'reg_start2',
	HomePageBannerClick = 'hp_banner_click',
	DepoStart = 'depo_start',
}

export type DataLayerEventParamsMap = {
	[DataLayerEventList.NotVerifiedPlayerSurvey]: undefined;
	[DataLayerEventList.PromotionChosenWhileRegistering]: {
		[DataLayerVariable.RegistrationPromotionId]: string;
		[DataLayerVariable.RegistrationPromotionName]: string;
	};
	[DataLayerEventList.BetError]: { [DataLayerVariable.BetErrorCodes]: string[] };
	[DataLayerEventList.DepositFalse]: {
		[DataLayerVariable.DepositValue]: number;
	};
	[DataLayerEventList.DepoStart]: { [DataLayerVariable.DepositOrigin]: ('panel gracza' | 'nawigacja')[] };
	[DataLayerEventList.RegStart2]: {
		[DataLayerVariable.RegAlt]?: string;
	};
	[DataLayerEventList.HomePageBannerClick]: {
		[DataLayerVariable.HpBannerImageAlt]: string;
		[DataLayerVariable.HpBannerPosition]: number[];
	};
};
